import React, { useMemo, useState } from 'react';
import './Products.css';
import { useLanguage } from '../LanguageContext';
import videoSrc from '../assets/Nest-Aura_ Real Estate1.mp4';

const Products = () => {
  const { t } = useLanguage();
  const [activeTab, setActiveTab] = useState('nestaura');

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const productTabs = useMemo(
    () => [
      {
        id: 'nestaura',
        tabLabel: t('nestAuraTab'),
        badge: `${t('recentlyLaunched')} 🚀`,
        title: 'NestAura.com',
        link: 'https://www.nest-aura.com',
        description: t('nestAuraDesc'),
        mediaType: 'video',
      },
      {
        id: 'smart-maintenance',
        tabLabel: t('smartMaintenanceTab'),
        badge: t('smartMaintenanceBadge'),
        title: t('smartMaintenanceTitle'),
        description: t('smartMaintenanceDesc'),
        panelTitle: t('smartMaintenanceTitle'),
        panelText: t('smartMaintenancePanelText'),
        mediaType: 'panel',
      },
      {
        id: 'coming-soon',
        tabLabel: t('comingSoonTab'),
        badge: t('comingSoonBadge'),
        title: t('comingSoonTitle'),
        description: t('comingSoonDesc'),
        panelTitle: t('comingSoonTitle'),
        panelText: t('comingSoonPanelText'),
        mediaType: 'panel',
      },
    ],
    [t]
  );

  const activeProduct = productTabs.find((item) => item.id === activeTab) || productTabs[0];

  return (
    <section id="products" className="products-section">
      <div className="products-content">
        <div className="products-header">
          <h2>{t('ourProducts')}</h2>
          <p>{t('productsDescription')}</p>
        </div>

        <div className="products-tabs" role="tablist" aria-label="Products tabs">
          {productTabs.map((item) => (
            <button
              key={item.id}
              type="button"
              role="tab"
              className={`products-tab ${activeTab === item.id ? 'active' : ''}`}
              aria-selected={activeTab === item.id}
              onClick={() => setActiveTab(item.id)}
            >
              {item.tabLabel}
            </button>
          ))}
        </div>
        
        <div className="product-showcase">
          <div className="product-info">
            <div className="launch-badge">{activeProduct.badge}</div>
            <h3 className="product-name">
              {activeProduct.link ? (
                <a href={activeProduct.link} target="_blank" rel="noreferrer">
                  {activeProduct.title}
                </a>
              ) : (
                activeProduct.title
              )}
            </h3>
            <p className="product-description">{activeProduct.description}</p>
            <button className="learn-more-btn" onClick={scrollToContact}>{t('needDemo')}</button>
          </div>
          
          <div className="product-video">
            {activeProduct.mediaType === 'video' ? (
              <div className="video-wrapper">
                <video
                  controls
                  playsInline
                  preload="auto"
                  className="product-video-player vertical"
                  src={videoSrc}
                  onClick={(e) => {
                    const v = e.currentTarget;
                    if (v.paused) v.play();
                  }}
                  onLoadedData={(e) => {
                    const v = e.currentTarget;
                    try {
                      v.currentTime = 0;
                      v.pause();
                    } catch {}
                  }}
                >
                  Your browser does not support the video tag.
                </video>
              </div>
            ) : (
              <div className="product-placeholder-card">
                <div className="product-placeholder-icon">
                  {activeProduct.id === 'smart-maintenance' ? '🛠️' : '✨'}
                </div>
                <h4>{activeProduct.panelTitle || activeProduct.title}</h4>
                <p>{activeProduct.panelText || activeProduct.description}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Products;
